import { useEffect, useState } from "react";
import { ancanaApi } from "../api/ancanaApi";
import { IContentType } from "../types/models";


const useContentType = (recordPath: string) => {
  const [contentType, setContentType] = useState<IContentType>();

  useEffect(() => {
    ancanaApi.options(recordPath).then(res => {
      setContentType(res.data?.content_type);
    });
  }, [recordPath]);

  return contentType;
};

export default useContentType;
